import AttendeeType from 'owa-service/lib/contract/AttendeeType';

export default function hasDistributionListInAttendees(attendees: AttendeeType[]): boolean {
    return attendees.some(attendee => {
        const mailbox = attendee.Mailbox;
        return (
            !!mailbox &&
            (mailbox.MailboxType == 'PrivateDL' ||
                mailbox.MailboxType == 'PublicDL' ||
                mailbox.MailboxType == 'GroupMailbox')
        );
    });
}
